var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconSort = function SvgIconSort(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 18
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "icon-sort_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M375 0v812H0V0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "icon-sort_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.674 0c.484 0 .877.372.877.831 0 .46-.484.831-.877.831H.878C.393 1.662 0 1.29 0 .832 0 .371.485 0 .878 0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "icon-sort_svg__c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.918 0c.485 0 .878.372.878.831 0 .46-.485.831-.878.831H.878C.393 1.662 0 1.29 0 .832 0 .371.485 0 .878 0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "icon-sort_svg__d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.286 0c.485 0 .877.372.877.831 0 .46-.484.831-.877.831H.878C.393 1.662 0 1.29 0 .832 0 .371.485 0 .878 0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "icon-sort_svg__e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.653 0c.485 0 .878.372.878.831 0 .46-.485.831-.878.831H.878C.393 1.662 0 1.29 0 .832 0 .371.485 0 .878 0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "icon-sort_svg__f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.498.221 3.723 3.527a.8.8 0 0 1 0 1.175c-.342.325-.963.264-1.24 0L.256 1.397a.8.8 0 0 1 0-1.176c.343-.325.963-.263 1.241 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "icon-sort_svg__g"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.198.244c.342.324.277.912 0 1.175L1.474 4.946a.91.91 0 0 1-1.24 0c-.343-.325-.278-.912 0-1.176L3.956.244a.91.91 0 0 1 1.24 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "icon-sort_svg__h"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.878 0c.484 0 .877.46.877.831v14.963c0 .459-.393.831-.877.831-.485 0-.878-.46-.878-.831V.83C0 .372.393 0 .878 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#icon-sort_svg__a)",
    transform: "translate(-333 -97)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#icon-sort_svg__b)",
    transform: "translate(334 98)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#002E5A",
    d: "M0 0h17.551v1.662H0z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#002E5A",
    strokeMiterlimit: 10,
    strokeWidth: 0.3,
    d: "M351.551 98.831c0 .46-.484.832-.877.832h-15.796c-.485 0-.878-.373-.878-.832s.485-.83.878-.83h15.796c.484 0 .877.371.877.83Z"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#icon-sort_svg__c)",
    transform: "translate(334 102.987)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#002E5A",
    d: "M0 0h15.796v1.662H0z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#002E5A",
    strokeMiterlimit: 10,
    strokeWidth: 0.3,
    d: "M349.796 103.819c0 .459-.484.83-.877.83h-14.041c-.485 0-.878-.371-.878-.83 0-.46.485-.832.878-.832h14.04c.485 0 .878.373.878.832Z"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#icon-sort_svg__d)",
    transform: "translate(334 107.975)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#002E5A",
    d: "M0 0h13.163v1.662H0z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#002E5A",
    strokeMiterlimit: 10,
    strokeWidth: 0.3,
    d: "M347.163 108.806c0 .46-.484.832-.877.832h-11.408c-.485 0-.878-.373-.878-.832s.485-.83.878-.83h11.408c.485 0 .877.371.877.83Z"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#icon-sort_svg__e)",
    transform: "translate(334 112.963)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#002E5A",
    d: "M0 0h10.53v1.662H0z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#002E5A",
    strokeMiterlimit: 10,
    strokeWidth: 0.3,
    d: "M344.531 113.794c0 .459-.485.831-.877.831h-8.776c-.485 0-.878-.372-.878-.831 0-.46.485-.831.878-.831h8.776c.484 0 .877.372.877.83Z"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#icon-sort_svg__f)",
    transform: "translate(350.197 109.458)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#002E5A",
    d: "M0 0h5.478v5.144H0z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#002E5A",
    strokeMiterlimit: 10,
    strokeWidth: 0.3,
    d: "M350.454 109.68c.343-.326.963-.264 1.241 0l3.724 3.526a.8.8 0 0 1 0 1.175c-.343.325-.964.264-1.242 0l-3.723-3.526a.8.8 0 0 1 0-1.176Z"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#icon-sort_svg__g)",
    transform: "translate(353.944 109.436)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#002E5A",
    d: "M0 0h5.431v5.19H0z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#002E5A",
    strokeMiterlimit: 10,
    strokeWidth: 0.3,
    d: "M359.142 109.68c.342.324.277.911 0 1.175l-3.724 3.526a.91.91 0 0 1-1.24 0c-.343-.324-.278-.912 0-1.175l3.723-3.527a.91.91 0 0 1 1.24 0Z"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#icon-sort_svg__h)",
    transform: "translate(353.92 98)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#002E5A",
    d: "M0 0h1.755v16.625H0z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#002E5A",
    strokeMiterlimit: 10,
    strokeWidth: 0.3,
    d: "M354.798 98c.484 0 .877.46.877.831v14.963c0 .459-.393.831-.877.831-.485 0-.878-.46-.878-.831V98.83c0-.459.393-.831.878-.831Z"
  }))));
};
export default SvgIconSort;